import { Loader } from "lucide-react";

const SplashOverlay = ({ splashOverlay, screenSize, t, styles }) => {
  if (!splashOverlay.visible) return null;

  return (
    <div style={styles.splashOverlay}>
      {splashOverlay.loading ? (
        <>
          <Loader
            size={screenSize.isMobile ? 40 : 48}
            className="animate-spin"
          />
          <p style={styles.splashMessage}>{t.loadingSplash}</p>
        </>
      ) : (
        <>
          {splashOverlay.url && (
            <img
              src={splashOverlay.url}
              alt={t.splashAltText}
              style={styles.splashImage}
            />
          )}
          <p style={styles.splashMessage}>{t.redirectingSoon}</p>
        </>
      )}
    </div>
  );
};

export default SplashOverlay;